/* module.exports = (fox) => {
	const options = require('../../../../common/components/sync-promo-landing')(fox);

	fox.registerOptions('@root', {
		mapGuest: options
	}, true, {});
} */


// WEBPACK FOOTER //
// ./dependencies/sync-promo.es.js